module.exports = __webpack_public_path__ + "static/img/live01.d1777f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/live01.png
// module id = Mx8I
// module chunks = 1